<template>
    <div class="form-field-constructor-item">
        <div class="form-field-constructor-item__head">
            <span class="form-field-constructor-item__handle" title="Перетащите, чтобы изменить порядок">⠿</span>
            <span class="form-field-constructor-item__index">Поле {{ position }}</span>
            <VButton
                type="button"
                class="button_orange button_small form-field-constructor-item__remove"
                @click="$emit('remove')"
            >
                Удалить
            </VButton>
        </div>

        <div class="form-field-constructor-item__grid">
            <ValidationProvider
                class="active-form__field"
                :vid="`label-${local.__uid}`"
                name="Название поля"
                rules="required|max:191"
                v-slot="{ errors }"
            >
                <label class="active-form__label active-form__label_required">Название поля</label>
                <VInput
                    class="active-form__control"
                    :class="{ error: errors[0] }"
                    placeholder="Например: Кому выдать"
                    :value="local.label"
                    @input="onLabelInput"
                />
                <span class="active-form__error">{{ errors[0] }}</span>
            </ValidationProvider>

            <div class="active-form__field">
                <label class="active-form__label">Тип поля</label>
                <VSelect
                    class="active-form__control"
                    :options="typeOptions"
                    label="title"
                    :reduce="(option) => option.type"
                    :clearable="false"
                    :searchable="false"
                    :value="local.type"
                    @input="onTypeChange"
                />
            </div>
        </div>

        <ValidationProvider
            class="active-form__field"
            :vid="`key-${local.__uid}`"
            name="Ключ поля"
            :rules="keyRules"
            v-slot="{ errors }"
        >
            <label class="active-form__label active-form__label_required">Ключ поля</label>
            <VInput
                class="active-form__control"
                :class="{ error: errors[0] }"
                placeholder="latin_key"
                :value="local.key"
                @input="onKeyInput"
            />
            <span class="active-form__error">{{ errors[0] }}</span>
            <span class="form-field-constructor-item__hint">
                Латиница, цифры и «_». Под этим ключом ответы хранятся в заявке — у сохранённого поля менять не
                рекомендуется.
            </span>
        </ValidationProvider>

        <label class="form-field-constructor-item__checkbox">
            <input type="checkbox" :checked="local.required" @change="onRequiredChange" />
            <span>Обязательное поле</span>
        </label>

        <div v-if="isSelectType" class="form-field-constructor-item__source">
            <label class="active-form__label">Источник вариантов</label>

            <div class="form-field-constructor-item__source-tabs">
                <label class="form-field-constructor-item__radio">
                    <input
                        type="radio"
                        :name="`source-${local.__uid}`"
                        :checked="source === 'static'"
                        @change="onSourceChange('static')"
                    />
                    <span>Свои варианты</span>
                </label>
                <label class="form-field-constructor-item__radio">
                    <input
                        type="radio"
                        :name="`source-${local.__uid}`"
                        :checked="source === 'dictionary'"
                        @change="onSourceChange('dictionary')"
                    />
                    <span>Справочник</span>
                </label>
            </div>

            <div v-if="source === 'dictionary'" class="active-form__field">
                <VSelect
                    class="active-form__control"
                    :options="dictionaries"
                    label="name"
                    :reduce="(option) => option.id"
                    :clearable="false"
                    placeholder="Выберите справочник"
                    :value="local.dictionaryId"
                    @input="onDictionaryChange"
                />
                <span v-if="!dictionaries.length" class="form-field-constructor-item__hint">
                    Пока нет ни одного справочника — создайте его в разделе «Справочники».
                </span>
            </div>

            <div v-else class="form-field-constructor-item__options">
                <div v-for="(option, i) in options" :key="i" class="form-field-constructor-item__option">
                    <ValidationProvider
                        class="active-form__field form-field-constructor-item__option-field"
                        :vid="`opt-value-${local.__uid}-${i}`"
                        name="Значение"
                        rules="required|max:191"
                        v-slot="{ errors }"
                    >
                        <VInput
                            class="active-form__control"
                            :class="{ error: errors[0] }"
                            placeholder="Значение"
                            :value="option.value"
                            @input="(value) => onOptionInput(i, 'value', value)"
                        />
                        <span class="active-form__error">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <ValidationProvider
                        class="active-form__field form-field-constructor-item__option-field"
                        :vid="`opt-label-${local.__uid}-${i}`"
                        name="Подпись"
                        rules="required|max:191"
                        v-slot="{ errors }"
                    >
                        <VInput
                            class="active-form__control"
                            :class="{ error: errors[0] }"
                            placeholder="Подпись"
                            :value="option.label"
                            @input="(value) => onOptionInput(i, 'label', value)"
                        />
                        <span class="active-form__error">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <VButton
                        v-if="options.length > 1"
                        type="button"
                        class="button_orange button_small form-field-constructor-item__option-remove"
                        title="Удалить вариант"
                        @click="removeOption(i)"
                    >
                        ×
                    </VButton>
                </div>

                <VButton type="button" class="button_green-light button_small" @click="addOption">
                    Добавить вариант
                </VButton>
            </div>
        </div>
    </div>
</template>
<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import VInput from '@/views/components/VInput/VInput.vue';
import VButton from '@/views/components/VButton/VButton.vue';
import VSelect from '@/views/components/VSelect/VSelect.vue';
import RequestServiceFormFieldType from '@/js/enums/RequestServiceFormFieldType';
import RequestServiceFormFieldTypeTitles from '@/js/enums/RequestServiceFormFieldTypeTitles';

function isSelectType(type) {
    return type === RequestServiceFormFieldType.SELECT || type === RequestServiceFormFieldType.MULTISELECT;
}

@Component({
    components: { ValidationProvider, VInput, VButton, VSelect },
})
class FormFieldConstructorItem extends Vue {
    @Prop({ type: Object, required: true }) value;
    @Prop({ type: Number, default: 0 }) position;
    @Prop({ type: Array, default: () => [] }) dictionaries;

    // Populated in created(), NOT here: a vue-class-component field initializer runs during data
    // collection before props are bound, so `this.value` would be undefined and every row would load
    // blank. __keyTouched is seeded so it stays reactive — setting it later (onKeyInput) has to
    // invalidate the isKeyAutoDerived computed, which a bare assignment onto a missing key would not.
    local = { __keyTouched: false };

    // The option source for a select, tracked explicitly rather than derived from dictionaryId: the
    // admin can select the "Справочник" source before a dictionary is chosen (or when none exist yet),
    // and that intent must stick so the dictionary UI — and its "no dictionaries" hint — keep showing.
    source = 'static';

    created() {
        this.local = { __keyTouched: false, ...this.value };
        this.source = this.local.dictionaryId ? 'dictionary' : 'static';
    }

    get typeOptions() {
        return Object.keys(RequestServiceFormFieldTypeTitles).map((type) => ({
            type: Number(type),
            title: RequestServiceFormFieldTypeTitles[type],
        }));
    }

    get isSelectType() {
        return isSelectType(this.local.type);
    }

    get options() {
        return (this.local.settings && this.local.settings.options) || [];
    }

    // Cached (no reactive deps) so the same object/RegExp is reused across renders instead of a fresh
    // one each time, which would make vee-validate re-normalise and re-validate on every keystroke.
    get keyRules() {
        return { required: true, regex: /^[a-z0-9_]+$/, max: 64 };
    }

    /**
     * The key is auto-derived from the label only while the admin has not taken it over — and a saved
     * field's key counts as taken over. Regenerating it would silently rewrite the key that every
     * already-submitted request's answers are stored under, just because someone fixed a typo in the
     * field's caption.
     */
    get isKeyAutoDerived() {
        return !this.local.__keyTouched && !this.local.id;
    }

    slugify(text) {
        const map = {
            а: 'a',
            б: 'b',
            в: 'v',
            г: 'g',
            д: 'd',
            е: 'e',
            ё: 'e',
            ж: 'zh',
            з: 'z',
            и: 'i',
            й: 'y',
            к: 'k',
            л: 'l',
            м: 'm',
            н: 'n',
            о: 'o',
            п: 'p',
            р: 'r',
            с: 's',
            т: 't',
            у: 'u',
            ф: 'f',
            х: 'h',
            ц: 'c',
            ч: 'ch',
            ш: 'sh',
            щ: 'sch',
            ъ: '',
            ы: 'y',
            ь: '',
            э: 'e',
            ю: 'yu',
            я: 'ya',
        };

        return text
            .toLowerCase()
            .split('')
            .map((char) => (map[char] !== undefined ? map[char] : char))
            .join('')
            .replace(/[^a-z0-9]+/g, '_')
            .replace(/^_+|_+$/g, '');
    }

    onLabelInput(value) {
        this.local.label = value;

        if (this.isKeyAutoDerived) {
            this.local.key = this.slugify(value || '');
        }
    }

    onKeyInput(value) {
        this.local.key = value;
        this.local.__keyTouched = true;
    }

    onRequiredChange(event) {
        this.local.required = event.target.checked;
    }

    onTypeChange(type) {
        this.local.type = type;

        // Options belong only to select/multiselect. When switching into a select, keep an existing
        // dictionary link if there is one, otherwise seed at least one hand-entered row so it can never
        // be saved empty. When switching to any other type, drop both option sources so the payload
        // never carries options or a dictionary the backend rejects for that type.
        if (isSelectType(type)) {
            if (!this.local.dictionaryId) {
                this.seedStaticOptions();
            }
        } else {
            this.local.settings = null;
            this.local.dictionaryId = null;
            this.source = 'static';
        }
    }

    onSourceChange(source) {
        this.source = source;

        if (source === 'dictionary') {
            // Options now come from a dictionary — drop any hand-entered ones and preselect the first
            // available dictionary so the field is immediately valid when at least one exists. When
            // none exist yet, dictionaryId stays null and the picker shows its "create one" hint.
            this.local.settings = null;
            this.local.dictionaryId = this.dictionaries.length ? this.dictionaries[0].id : null;
        } else {
            this.local.dictionaryId = null;
            this.seedStaticOptions();
        }
    }

    onDictionaryChange(id) {
        this.local.dictionaryId = id || null;
    }

    seedStaticOptions() {
        const options =
            this.local.settings && Array.isArray(this.local.settings.options) ? this.local.settings.options : [];

        this.$set(this.local, 'settings', {
            options: options.length ? options : [{ value: '', label: '' }],
        });
    }

    onOptionInput(index, field, value) {
        this.local.settings.options[index][field] = value;
    }

    addOption() {
        this.local.settings.options.push({ value: '', label: '' });
    }

    removeOption(index) {
        // Keep at least one option row so a select can never end up with an empty list.
        if (this.local.settings.options.length <= 1) {
            return;
        }

        this.local.settings.options.splice(index, 1);
    }

    /**
     * Deep, so any edit — label, key, type, required flag, or an option — is reported back to the
     * parent list from one place, keeping the constructor's v-model in sync.
     */
    @Watch('local', { deep: true })
    onLocalChange() {
        this.$emit('input', this.local);
    }
}

export default FormFieldConstructorItem;
</script>
<style lang="scss">
.form-field-constructor-item {
    margin-bottom: 16px;
    padding: 16px;
    background: #ffffff;
    border: 1px solid var(--active-form-control-border, #e5e4e5);
    border-radius: 10px;

    &__head {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;
    }

    &__handle {
        color: #b5b5b5;
        font-size: 1.25rem;
        line-height: 1;
        cursor: grab;
        user-select: none;
    }

    &__index {
        flex: 1 1 auto;
        color: #9b9b9b;
        font-size: 0.8125rem;
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 0.03em;
    }

    &__remove.button {
        flex: 0 0 auto;
        width: auto;
    }

    &__grid {
        display: grid;
        grid-template-columns: 1fr 220px;
        gap: 12px;

        @media (max-width: 640px) {
            grid-template-columns: 1fr;
        }
    }

    // Tighten the shared active-form spacing inside a field card.
    .active-form__field {
        margin-bottom: 12px;
    }

    &__hint {
        display: block;
        margin-top: 4px;
        color: #9b9b9b;
        font-size: 0.75rem;
        line-height: 1.3;
    }

    &__checkbox {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;
        font-size: 0.875rem;
        cursor: pointer;

        input {
            width: auto;
            height: auto;
            margin: 0;
        }
    }

    &__source {
        padding-top: 12px;
        border-top: 1px solid var(--active-form-control-border, #e5e4e5);
    }

    &__source-tabs {
        display: flex;
        gap: 16px;
        margin: 8px 0 12px;
    }

    &__radio {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        font-size: 0.875rem;
        cursor: pointer;

        input {
            width: auto;
            height: auto;
            margin: 0;
        }
    }

    &__option {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        margin-bottom: 8px;
    }

    &__option-field {
        flex: 1 1 0;
        min-width: 0;
        margin-bottom: 0 !important;
    }

    &__option-remove.button {
        flex: 0 0 auto;
        width: auto;
        margin-top: 4px;
    }
}
</style>
